import { ComponentsVariants } from '@mui/material/styles';

const variants: ComponentsVariants['MuiLink'] = [];

export default variants;
